import { useQuery } from 'react-query';
import { AxiosError } from 'axios';
import { Axios } from '../axios-instance';
import { BaseError } from '@utils/types/shared/base';
import { LicenseRequestListResponse } from '@utils/types/resellers/license-request';

const URL_EXTENSION = 'api/v3';

export const RESELLER_LICENSE_REQUESTS_QUERY_KEY = 'resellerLicenseRequests';

const fetchLicenseRequests = async (
  customerId: string
): Promise<LicenseRequestListResponse> => {
  const response = await Axios.get<LicenseRequestListResponse>(
    `${URL_EXTENSION}/reseller/customer/${customerId}/license-request`
  );
  return response.data;
};

export const useGetLicenseRequests = (customerId: string) => {
  return useQuery<LicenseRequestListResponse, AxiosError<BaseError>>(
    [RESELLER_LICENSE_REQUESTS_QUERY_KEY, customerId],
    () => fetchLicenseRequests(customerId),
    {
      enabled: !!customerId,
      useErrorBoundary: false,
      staleTime: 30 * 1000, // 30 seconds
      cacheTime: 5 * 60 * 1000 // 5 minutes
    }
  );
};
